module.exports = __webpack_public_path__ + "img/camera.00c95aa3.svg";